export const mapWidgetModel = {
  isMain: false,
  positionX: 0,
  positionY: 0,
  positionZ: 0,
  sceneId: null,
  type: null,
  name: '',
  altitude: 0,
};

export const mapConnectorModel = {
  endWidget: null,
  startWidget: null,
};

export function getDataFromModel(object, model) {
  return Object.keys(model).reduce((res, currentKey) => {
    if (Object.prototype.hasOwnProperty.call(object, currentKey)) {
      res[currentKey] = object[currentKey];
    }
    return res;
  }, {});
}



// WEBPACK FOOTER //
// ./src/helpers/models.js